import SliderSection from "../../components/Landing/SliderSection";
import WelcomeSection from "../../components/Landing/WelcomeSection";
import AdvantageSection from "../../components/Landing/AdvantageSection";
import PoliciesSection from "../../components/Landing/PoliciesSection";
import OpportunitySection from "../../components/Landing/OpportunitySection";
import InvestmentSectorSection from "../../components/Landing/InvestmentSectorSection";
import TourismGrowthSection from "../../components/Landing/TourismGrowthSection";
import BrandLogoSection from "../../components/Landing/BrandLogoSection";
import KeyStatisticsSection from "../../components/Landing/KeyStatisticsSection";
import ContactMapSection from "../../components/Landing/ContactMapSection";
import HomeLayout from "./HomeLayout";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const sectionId = location.state.scrollTo;

      // Small delay ensures the DOM is rendered
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 200);
    }
  }, [location]);

  return (
    <>
      <HomeLayout>
        <SliderSection />
        <WelcomeSection />
        <AdvantageSection />
        <PoliciesSection />
        <OpportunitySection />
        <InvestmentSectorSection />
        <TourismGrowthSection />
        <BrandLogoSection />
        <KeyStatisticsSection />
        <ContactMapSection />
      </HomeLayout>
    </>
  );
};

export default Home;
